import { Font } from '@react-pdf/renderer';

type HyphenationCallback = Parameters<typeof Font.registerHyphenationCallback>[0];

/**
 * Renders with automatic hyphenation OFF, then restores whatever was set.
 *
 * @react-pdf hyphenates with English rules: a Spanish document came out with
 * "Pred-icación" and "Expos-itiva". Words simply wrap whole instead. The
 * callback is a process-wide setting shared by every PDF in the app (the CAP
 * documents are in English and keep theirs), so it is switched off only for the
 * duration of one render.
 */
export async function renderWithoutHyphenation<T>(render: () => Promise<T>): Promise<T> {
  const previous = Font.getHyphenationCallback() as HyphenationCallback | null;
  Font.registerHyphenationCallback((word) => [word]);
  try {
    return await render();
  } finally {
    Font.registerHyphenationCallback(previous as HyphenationCallback);
  }
}
